import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DatalayerService } from 'src/services/datalayer.service';
import { HubService } from 'src/services/hub.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-drug-shortages-panel',
  templateUrl: './drug-shortages-panel.component.html',
  styleUrls: ['./drug-shortages-panel.component.scss']
})
export class DrugShortagesPanelComponent implements OnInit, AfterViewInit {

  shortageHtml: SafeHtml | null = null;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private datalayerService: DatalayerService,
    private hubService: HubService,
    public translationService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.loadShortages();
  }

  ngAfterViewInit(): void {
    // Event delegation for dynamically injected HTML
    this.elementRef.nativeElement.addEventListener('click', (event: any) => {
      const link = event.target.closest('[data-shortage-link]');
      if (!link) return;

      const title = link.getAttribute('data-title');
      const value = link.getAttribute('data-value');

      this.drugShortageClick(title, value);
      window.open(value, "_blank");
    });
  }

  loadShortages() {
    this.hubService.getShortages(this.translationService.currentLang).subscribe({
      next: data => {

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, 'application/xml');

        const elements = Array.from(xmlDoc.getElementsByTagName('element'));
        const wrapper = document.createElement('div');

        elements.forEach(element => {

          const shortageCard = document.createElement('div');
          shortageCard.setAttribute('class', 'shortage-card');

          const shortageContainer = document.createElement('div');
          shortageContainer.setAttribute('class', 'shortage-content');

          const linkContainer = document.createElement('div');
          linkContainer.setAttribute('class', 'shortage-title');

          const rawTitle = element.getElementsByTagName('title')[0]?.textContent || '';
          const rawLink  = element.getElementsByTagName('href')[0]?.textContent || '';

          const cleanedTitle = rawTitle.trim();
          const cleanedLink  = rawLink.trim();

          const anchor = document.createElement('span');
          anchor.style.cursor = 'pointer';
          anchor.style.textDecoration = 'underline';
          anchor.style.color = '#00819E';

          // Analytics attributes
          anchor.setAttribute('data-shortage-link', 'true');
          anchor.setAttribute('data-title', cleanedTitle);
          anchor.setAttribute('data-value', cleanedLink);

          anchor.textContent = cleanedTitle;
          
          linkContainer.appendChild(anchor);

          const descriptionContainer = document.createElement('div');
          descriptionContainer.setAttribute('class', 'shortage-description');
          descriptionContainer.textContent = element.getElementsByTagName('description')[0].textContent;

          shortageContainer.appendChild(linkContainer);
          shortageContainer.appendChild(descriptionContainer);

          shortageCard.appendChild(shortageContainer);
          
          wrapper.appendChild(shortageCard);

        });

        this.shortageHtml = this.sanitizer.bypassSecurityTrustHtml(wrapper.innerHTML);
      },
      error: err => {
        console.error('Failed fetch drug shortage XML', err);
      }
    });
  }
  
  drugShortageClick(title: string, value: string) {
      this.datalayerService.drugShortageClick(title, value);
  }

  onReadAllClick() {
    const title = this.translationService.instant('Home.readmore');
    const text  = title; 

    const value =
      this.translationService.currentLang === 'fr'
        ? "https://www.pharmacists.ca/representation/enjeux/penuries-de-medicaments/gestion-des-penuries-de-medicaments-actuelles/?lang=fr"
        : "https://www.pharmacists.ca/advocacy/issues/drug-shortages/managing-current-drug-shortages/";

    this.drugShortageClick(text, value);
    window.open(value, "_blank");
  }
}